var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "record-file-upload" }, [
    _c("div", { staticClass: "collapse-body" }, [
      _c("h3", [_vm._v("Dateien")]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-6 align-self-center" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Zuordnung" } },
              [
                _c("b-form-select", {
                  attrs: { options: _vm.categoryGroupOptions, required: true },
                  model: {
                    value: _vm.selectedCategoryGroup,
                    callback: function ($$v) {
                      _vm.selectedCategoryGroup = $$v
                    },
                    expression: "selectedCategoryGroup",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Kategorie" } },
              [
                _c("b-form-select", {
                  attrs: {
                    disabled: !_vm.selectedCategoryGroup,
                    options: _vm.categoryOptions,
                    required: true,
                  },
                  model: {
                    value: _vm.selectedCategory,
                    callback: function ($$v) {
                      _vm.selectedCategory = $$v
                    },
                    expression: "selectedCategory",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 align-self-center" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("csp-record-file-upload", {
                ref: "dropzone",
                attrs: {
                  category: _vm.selectedCategory,
                  "category-group": _vm.selectedCategoryGroup,
                  "multiple-upload": true,
                  "record-id": _vm.recordId,
                },
                on: { "upload-success": _vm.handleUploadSuccess },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }